const r="danger",e=["success",r],n=[r],a=["default","primary","secondary","tertiary","link","inline","brand",...n];export{e as colors,n as deprecatedVariants,a as variants};
//# sourceMappingURL=variants.js.map
